<template>
  <div v-if="isVisible" class="page-loading-overlay">
    <div class="page-loading-content">
      <div class="page-loading-spinner"></div>
      <div class="page-loading-text">{{ text || 'Procesando...' }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isVisible?: boolean
  text?: string
}

defineProps<Props>()
</script>

<style scoped>
.page-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.page-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: #ffffff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
}

.page-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #003896;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.page-loading-text {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #2b2a2a;
  text-align: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
